import React, { useState } from "react";
import { Row, Col, Button, Form,Table, Select,Checkbox } from "antd";
import { RightOutlined , MailOutlined} from "@ant-design/icons";
//import { DropdownCheckBox } from "../../../atoms/UIDropdown/Dropdown";
import styled from "styled-components";
import { uniqBy } from "lodash";
import { getLocations } from "../../../Redux/selectors";
import { connect } from "react-redux";
//import {StyledTable} from "atoms/Table";
import { utils, writeFileXLSX } from "xlsx";

const Customstyle = styled.div`
  .head {
    display: flex;
    align-item: center;
    justify-content: space-between;
    color: #1B1B1B;
    font-weight: bold;
  }
    .ant-table-tbody > tr > td {
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.5;
    color: #000000;
    vertical-align: none !important;
  }
`;
const CustomTableWrapper = styled.div`
  .ant-table-thead > tr > th {
    background-color: #f4f4f4;
    font-weight: bold;
    color: #1b1b1b;
  }

  .ant-table-tbody > tr > td {
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.5;
    color: #000000;
    vertical-align: none; !important
  }
`;
function Cv({ locationList }) {
  const [form] = Form.useForm();
  const [filteredData, setFilteredData] = useState([]);
  const dataSource = [
    {
      key: '1',
      name: 'Abenelek DANIEL',
      summaryProfile: 'Angel Champions Government and Public Sector',
      industry: 'Professional Services',
      competency: 'ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory)',
      position: 'Audit Associate',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '2',
      name: 'Agegnehu TESFA',
      summaryProfile: 'Angelique currently runs BDO Corporate Advisory Ltd (Rwanda). She is a seasoned economist and financial strategist with 27+ years of banking leadership and financial development experience in the public and private financial sectors. Her area of expertise lies in financial reform strategy, facilitating smooth mergers and securing investors, executive management, commercial banking, banking supervision, market analysis, regulatory trends forecasting, microfinance strategy, strategic planning, technology solutions, cross-functional team leadership, performance assessment, client relationship management and project management. She drives business growth and achievement through effective communication skills, negotiation skills, business acumen, systems analysis and resource management. Angelique holds a Master’s of Public Administration (M.P.A.) in Public Policy and Management (Mason Fellow) from Harvard University, John F. Kennedy School of Government, Cambridge, MA and a Bachelor and Master Degree in Economics and Social Sciences from the Faculties Universities ‘Notre-Dame de la Paix, Namur, Belgium',
      industry: 'Agribusiness, Floriculture and Fisheries, Banking, Insurance and other Financial Services, Betting, Chemicals, Consumer Business (includes Retail, Leisure & Hospitality & Gaming), Diversified Group, Education, Engineering, Government and Public Sector, Health Care, Hospitality & Tourism, Logistics, Retail and Supply Chain, Manufacturing & Distributions, Mining Oil & Gas, Natural Resources & Energy, Not for Profit, Professional Services, Services , Technologies, Media and Telecom',
      competency: 'ADM | Finance and Administration, ADV | Corporate Finance, Transactions, Restructuring & M&A, ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory), ADV | Risk Management (RAS), Forensics Investigations, Risk, Regulatory & Compliance, ADV | Technology Advisory, Cyber security, Analytics & Insights',
      position: 'Partner',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '3',
      name: 'Abenelek DANIEL',
      summaryProfile: 'Angel Champions Government and Public Sector',
      industry: 'Professional Services',
      competency: 'ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory)',
      position: 'Audit Associate',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '4',
      name: 'Abenelek DANIEL',
      summaryProfile: 'Angel Champions Government and Public Sector',
      industry: 'Professional Services',
      competency: 'ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory)',
      position: 'Audit Associate',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '5',
      name: 'Abenelek DANIEL',
      summaryProfile: 'Angel Champions Government and Public Sector',
      industry: 'Professional Services',
      competency: 'ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory)',
      position: 'Audit Associate',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '6',
      name: 'Agegnehu TESFA',
      summaryProfile: 'Angelique currently runs BDO Corporate Advisory Ltd (Rwanda). She is a seasoned economist and financial strategist with 27+ years of banking leadership and financial development experience in the public and private financial sectors. Her area of expertise lies in financial reform strategy, facilitating smooth mergers and securing investors, executive management, commercial banking, banking supervision, market analysis, regulatory trends forecasting, microfinance strategy, strategic planning, technology solutions, cross-functional team leadership, performance assessment, client relationship management and project management. She drives business growth and achievement through effective communication skills, negotiation skills, business acumen, systems analysis and resource management. Angelique holds a Master’s of Public Administration (M.P.A.) in Public Policy and Management (Mason Fellow) from Harvard University, John F. Kennedy School of Government, Cambridge, MA and a Bachelor and Master Degree in Economics and Social Sciences from the Faculties Universities ‘Notre-Dame de la Paix, Namur, Belgium.',
      industry: 'Agribusiness, Floriculture and Fisheries, Banking, Insurance and other Financial Services, Betting, Chemicals, Consumer Business (includes Retail, Leisure & Hospitality & Gaming), Diversified Group, Education, Engineering, Government and Public Sector, Health Care, Hospitality & Tourism, Logistics, Retail and Supply Chain, Manufacturing & Distributions, Mining Oil & Gas, Natural Resources & Energy, Not for Profit, Professional Services, Services , Technologies, Media and Telecom',
      competency: 'ADM | Finance and Administration, ADV | Corporate Finance, Transactions, Restructuring & M&A, ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory), ADV | Risk Management (RAS), Forensics Investigations, Risk, Regulatory & Compliance, ADV | Technology Advisory, Cyber security, Analytics & Insights',
      position: 'Partner',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '7',
      name: 'Abenelek DANIEL',
      summaryProfile: 'Angel Champions Government and Public Sector',
      industry: 'Professional Services',
      competency: 'ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory)',
      position: 'Audit Associate',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '8',
      name: 'Abenelek DANIEL',
      summaryProfile: 'Angel Champions Government and Public Sector',
      industry: 'Professional Services',
      competency: 'ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory)',
      position: 'Audit Associate',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '9',
      name: 'Abenelek DANIEL',
      summaryProfile: 'Angel Champions Government and Public Sector',
      industry: 'Professional Services',
      competency: 'ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory)',
      position: 'Audit Associate',
      managementOffice: 'BDO EA Ethiopia',
    },
    {
      key: '10',
      name: 'Agegnehu TESFA',
      summaryProfile: 'Angelique currently runs BDO Corporate Advisory Ltd (Rwanda). She is a seasoned economist and financial strategist with 27+ years of banking leadership and financial development experience in the public and private financial sectors. Her area of expertise lies in financial reform strategy, facilitating smooth mergers and securing investors, executive management, commercial banking, banking supervision, market analysis, regulatory trends forecasting, microfinance strategy, strategic planning, technology solutions, cross-functional team leadership, performance assessment, client relationship management and project management. She drives business growth and achievement through effective communication skills, negotiation skills, business acumen, systems analysis and resource management. Angelique holds a Master’s of Public Administration (M.P.A.) in Public Policy and Management (Mason Fellow) from Harvard University, John F. Kennedy School of Government, Cambridge, MA and a Bachelor and Master Degree in Economics and Social Sciences from the Faculties Universities ‘Notre-Dame de la Paix, Namur, Belgium.',
      industry: 'Agribusiness, Floriculture and Fisheries, Banking, Insurance and other Financial Services, Betting, Chemicals, Consumer Business (includes Retail, Leisure & Hospitality & Gaming), Diversified Group, Education, Engineering, Government and Public Sector, Health Care, Hospitality & Tourism, Logistics, Retail and Supply Chain, Manufacturing & Distributions, Mining Oil & Gas, Natural Resources & Energy, Not for Profit, Professional Services, Services , Technologies, Media and Telecom',
      competency: 'ADM | Finance and Administration, ADV | Corporate Finance, Transactions, Restructuring & M&A, ADV | Management Consultancy (Strategy, HR, PM, Devt. Advisory), ADV | Risk Management (RAS), Forensics Investigations, Risk, Regulatory & Compliance, ADV | Technology Advisory, Cyber security, Analytics & Insights',
      position: 'Partner',
      managementOffice: 'BDO EA Ethiopia',
    },
  ];
const [loading, setLoading] = useState(false);
  const columns = [
    {
      title: 'Action',
      key: 'action',
      render: () => <div
      style={{
        position: 'relative', // Allows proper positioning of the icon
        width: '35px',
        height: '35px',
        background: '#C2FAE5 0% 0% no-repeat padding-box',
        borderRadius: '5px',
        display: 'flex', // Centers the icon inside the box
      }}
    >
      <MailOutlined style={{ fontSize: '16px', color: '#000000' ,paddingLeft:"9px"}} />
    </div>  },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: 500,
      ellipsis: false, // Disable truncation
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
     
    },
    {
      title: 'Summary Profile',
      dataIndex: 'summaryProfile',
      key: 'summaryProfile',
      width: 900,
      ellipsis: false, 
    render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', color: '#000000'}}>{text}</div>, 
    },
    {
      title: 'Industry',
      dataIndex: 'industry',
      key: 'industry',
      width: 700,
      ellipsis: false, // Disable truncation
    render: (text) => <div style={{  whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5', textAlign: 'left',color: '#000000',paddingTop:'0px'}}>{text}</div>, // Truncate long text
   
    },
    {
      title: 'Competency',
      dataIndex: 'competency',
      key: 'competency',
      width: 500,
      ellipsis: false, // Disable truncation
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
     
    },
    {
      title: 'Position',
      dataIndex: 'position',
      key: 'position',
      width: 500,
      ellipsis: false, // Disable truncation
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
     
    },
    {
      title: 'Management Office',
      dataIndex: 'managementOffice',
      key: 'managementOffice',
      width: 500,
      ellipsis: false, // Disable truncation
      render: (text) => <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', lineHeight: '1.5',color: '#000000'}}>{text}</div>, // Truncate long text
     
    },
  ];
  const xport = React.useCallback(() => {
    const elt = document.getElementById("Table");
    const wb = utils.table_to_book(elt);
    writeFileXLSX(wb, "proposalprep-CV.xlsx");
  });
  return (
    <>
      <Customstyle>
        <Row gutter={16}>
          <Col xl={24} sm={24} xs={24}>
            <div className="head">
              <div>
                <span>Proposal Prep </span>{" "}
                <RightOutlined className="Right_outlined" />
                <span> CV</span>
              </div>
              <div style={{ display: "flex", gap: "10px" }}>
              <Button 
               type="primary"
               style={{ backgroundColor: "#C2FAE5",color:"#000000"}}
               >Import CV</Button>
              <Button 
               onClick={xport}
               type="primary"
               style={{ backgroundColor: "#C2FAE5",color:"#000000"}}>Export CSV</Button>
              </div>

            </div>
          </Col>
        </Row>
        <br />

<Row gutter={12} className="g-3 mb-2">
  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
    <Checkbox.Group>
      <label>Managing Office</label>
      {/* Options can be added here later if needed */}
    </Checkbox.Group>
  </Col>
  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
    <Checkbox.Group>
      <label>Employee</label>
      {/* Options can be added here later if needed */}
    </Checkbox.Group>
  </Col>
  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
    <Checkbox.Group>
      <label>Competency</label>
      {/* Options can be added here later if needed */}
    </Checkbox.Group>
  </Col>
  <Col xs={24} sm={24} md={12} lg={8} xl={4}>
    <Checkbox.Group>
      <label>Industry</label>
      {/* Options can be added here later if needed */}
    </Checkbox.Group>
  </Col>
  <Col xs={24} sm={24} md={12} lg={8} xl={8}>
    <Checkbox.Group>
      <label>Certification</label>
      {/* Options can be added here later if needed */}
    </Checkbox.Group>
  </Col>
</Row>

        {/* <Row>
          <Col sm={24} lg={12}>
            <span style={{fontWeight:"bold"}}>Items per page:</span>{" "}
            <Select
              defaultValue={filteredData?.length || 0}

              dropdownStyle={{ maxHeight: 100 }}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 50, label: "50" },
                {
                  value: filteredData?.length,
                  label: `${filteredData?.length}`,
                },
              ]}
            />
          </Col>
        </Row> */}
        <Row>
          <Col sm={24} lg={12}>
          Total People : {dataSource?.length}</Col>
        </Row>
        <Table
                dataSource={dataSource}
                columns={columns}
                size="middle"
                pagination={false}
                loading={loading}
                id="Table"
              />
      </Customstyle>
    </>
  );
}
const mapStateToProps = (state) => ({
  locationList: getLocations(state),
});
export default connect(mapStateToProps)(Cv);